import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Card — surface-level container primitive.
 *
 * Sketched in Claude Design 2026-05-10 (dashboard); extended for login 2026-05-19.
 * Rationale: --bg-surface background with 1.5 px --border-default,
 * --radius-xl (12 px) corners. Used for portal-select cards and any
 * composable surface that needs visual separation without elevation.
 */
import * as React from 'react';
import { Slot } from '@radix-ui/react-slot';
import { cn } from './cn.js';
const VARIANT_CLASSES = {
    surface: 'bg-[var(--bg-surface)] border border-solid border-[var(--border-subtle)] rounded-2xl',
    sunken: 'bg-[var(--bg-sunken)] border border-dashed border-[var(--border-default)] rounded-xl',
};
const PADDING_CLASSES = {
    none: 'p-0',
    sm: 'p-3',
    md: 'p-5',
    lg: 'p-6',
};
export const Card = React.forwardRef(function Card({ variant = 'surface', padding = 'md', asChild = false, children, className, ...rest }, ref) {
    const composed = cn(VARIANT_CLASSES[variant], PADDING_CLASSES[padding], className);
    if (asChild) {
        return (_jsx(Slot, { ref: ref, className: composed, ...rest, children: children }));
    }
    return (_jsx("div", { ref: ref, className: composed, ...rest, children: children }));
});
Card.displayName = 'Card';
//# sourceMappingURL=Card.js.map